import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "./suggested_wm_cell.module.scss";

export const OpenVacancy = () => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles.suggestedWmSidePanel" });
  return (
    <Inline alignItems="center">
      <Icon name="missing" color="paletteBlue2" />
      <Typography variant="labelRegular" className={css.openVacancy}>
        {t("noSuggestedWm")}
      </Typography>
    </Inline>
  );
};
